// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campeonatos-container {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

.campeonatos-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}

.campeonatos-header h1 {
  font-size: 28px;
  color: var(--brand-navy, #111827);
  margin: 0 0 8px 0;
}

.campeonatos-header p {
  color: #6B7280;
  margin: 0;
}

.campeonatos-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #6B7280;
  font-size: 16px;
}

/* Grid de Campeonatos */
.campeonatos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 32px;
}

.campeonato-card {
  background: var(--bg-surface, #ffffff);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s, box-shadow 0.2s;
  display: flex;
  flex-direction: column;
}

.campeonato-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
}

.camp-cover {
  height: 240px;
  background-size: cover;
  background-position: center;
  background-color: #E5E7EB;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 16px;
  position: relative;
}

.camp-cover::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.6) 100%);
}

.camp-cover > span {
  color: #6B7280;
  font-size: 14px;
  font-weight: 600;
  margin: auto;
  z-index: 1;
}

.camp-status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  z-index: 1;
  background: #374151;
  color: #fff;
}

.camp-status.inscrições.abertas {
  background: #10B981;
}

.camp-info {
  padding: 20px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.camp-info h3 {
  margin: 0 0 12px 0;
  font-size: 18px;
  color: #111827;
  line-height: 1.3;
}

.camp-date, .camp-location {
  font-size: 14px;
  color: #4B5563;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.camp-actions {
  margin-top: auto;
  padding-top: 16px;
  display: flex;
  justify-content: flex-end;
}

/* Empty State */
.empty-state {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  background: var(--bg-surface, #ffffff);
  border-radius: 12px;
  border: 2px dashed #E5E7EB;
  text-align: center;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-state h3 {
  margin: 0 0 8px 0;
  color: #111827;
}

.empty-state p {
  color: #6B7280;
  margin: 0;
}

/* Wizard Forms */
.wizard-header {
  margin-bottom: 32px;
  text-align: center;
}

.wizard-header h1 {
  font-size: 28px;
  margin-bottom: 16px;
}

.wizard-steps-indicator {
  display: inline-flex;
  align-items: center;
  background: var(--bg-surface, #fff);
  padding: 8px 24px;
  border-radius: 30px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.wizard-steps-indicator span {
  font-size: 14px;
  color: #9CA3AF;
  font-weight: 600;
  transition: color 0.3s;
}

.wizard-steps-indicator span.active {
  color: var(--brand-navy, #111827);
}

.wizard-steps-indicator .separator {
  margin: 0 16px;
  color: #E5E7EB;
}

.wizard-body {
  background: var(--bg-surface, #fff);
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.05);
  margin-bottom: 24px;
}

.wizard-step h2 {
  font-size: 22px;
  margin: 0 0 24px 0;
  color: #111827;
  border-bottom: 1px solid #F3F4F6;
  padding-bottom: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-row {
  display: flex;
  gap: 16px;
}

.form-group.flex-1 { flex: 1 1; }
.form-group.flex-2 { flex: 2 1; }

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.form-group input, 
.form-group select {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  font-size: 15px;
  color: #111827;
  transition: all 0.2s;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--brand-navy, #111827);
  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.1);
}

.help-text {
  font-size: 13px;
  color: #6B7280;
  margin: 6px 0 0 0;
}

.section-block {
  background: #F9FAFB;
  border: 1px solid #F3F4F6;
  padding: 24px;
  border-radius: 12px;
  margin-bottom: 24px;
}

.section-block h3 {
  margin: 0 0 16px 0;
  font-size: 16px;
  color: #374151;
}

/* Upload Container */
.upload-container {
  margin-top: 16px;
}

.upload-placeholder {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  border: 2px dashed #D1D5DB;
  border-radius: 12px;
  background: #F9FAFB;
  cursor: pointer;
  transition: all 0.2s;
}

.upload-placeholder:hover {
  border-color: var(--brand-navy, #111827);
  background: #F3F4F6;
}

.upload-placeholder span {
  font-weight: 600;
  color: #6B7280;
}

.upload-placeholder input[type="file"] {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  opacity: 0;
  cursor: pointer;
}

.capa-preview {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.capa-preview img {
  max-width: 100%;
  max-height: 400px;
  border-radius: 12px;
  object-fit: contain;
  border: 1px solid #E5E7EB;
}

/* Footer Wizard */
.wizard-footer {
  display: flex;
  align-items: center;
  padding: 0 16px;
}

/* Buttons */
.btn-primary {
  background-color: var(--brand-navy, #111827);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #374151;
}

.btn-primary.success {
  background-color: #10B981;
}
.btn-primary.success:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: var(--brand-navy, #111827);
  border: 1px solid var(--brand-navy, #111827);
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-outline:hover {
  background-color: var(--brand-navy, #111827);
  color: white;
}

.btn-outline.small {
  padding: 6px 12px;
  font-size: 13px;
}

.btn-outline.danger {
  color: #EF4444;
  border-color: #EF4444;
}
.btn-outline.danger:hover {
  background-color: #EF4444;
  color: white;
}

.mt-2 {
  margin-top: 16px;
}

.summary-alert {
  background: #ECFDF5;
  border: 1px solid #34D399;
  padding: 16px;
  border-radius: 8px;
  color: #065F46;
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Campeonatos.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,mGAAmG;AACrG;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,qBAAqB,SAAO,EAAE;AAC9B,qBAAqB,SAAO,EAAE;;AAE9B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,4CAA4C;EAC5C,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,4CAA4C;EAC5C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".campeonatos-container {\n  padding: 24px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.campeonatos-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n}\n\n.campeonatos-header h1 {\n  font-size: 28px;\n  color: var(--brand-navy, #111827);\n  margin: 0 0 8px 0;\n}\n\n.campeonatos-header p {\n  color: #6B7280;\n  margin: 0;\n}\n\n.campeonatos-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  color: #6B7280;\n  font-size: 16px;\n}\n\n/* Grid de Campeonatos */\n.campeonatos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n  gap: 32px;\n}\n\n.campeonato-card {\n  background: var(--bg-surface, #ffffff);\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\n  transition: transform 0.2s, box-shadow 0.2s;\n  display: flex;\n  flex-direction: column;\n}\n\n.campeonato-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);\n}\n\n.camp-cover {\n  height: 240px;\n  background-size: cover;\n  background-position: center;\n  background-color: #E5E7EB;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  padding: 16px;\n  position: relative;\n}\n\n.camp-cover::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: linear-gradient(to bottom, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0) 50%, rgba(0,0,0,0.6) 100%);\n}\n\n.camp-cover > span {\n  color: #6B7280;\n  font-size: 14px;\n  font-weight: 600;\n  margin: auto;\n  z-index: 1;\n}\n\n.camp-status {\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  z-index: 1;\n  background: #374151;\n  color: #fff;\n}\n\n.camp-status.inscrições.abertas {\n  background: #10B981;\n}\n\n.camp-info {\n  padding: 20px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.camp-info h3 {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  color: #111827;\n  line-height: 1.3;\n}\n\n.camp-date, .camp-location {\n  font-size: 14px;\n  color: #4B5563;\n  margin: 0 0 8px 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.camp-actions {\n  margin-top: auto;\n  padding-top: 16px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* Empty State */\n.empty-state {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  background: var(--bg-surface, #ffffff);\n  border-radius: 12px;\n  border: 2px dashed #E5E7EB;\n  text-align: center;\n}\n\n.empty-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.empty-state h3 {\n  margin: 0 0 8px 0;\n  color: #111827;\n}\n\n.empty-state p {\n  color: #6B7280;\n  margin: 0;\n}\n\n/* Wizard Forms */\n.wizard-header {\n  margin-bottom: 32px;\n  text-align: center;\n}\n\n.wizard-header h1 {\n  font-size: 28px;\n  margin-bottom: 16px;\n}\n\n.wizard-steps-indicator {\n  display: inline-flex;\n  align-items: center;\n  background: var(--bg-surface, #fff);\n  padding: 8px 24px;\n  border-radius: 30px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n}\n\n.wizard-steps-indicator span {\n  font-size: 14px;\n  color: #9CA3AF;\n  font-weight: 600;\n  transition: color 0.3s;\n}\n\n.wizard-steps-indicator span.active {\n  color: var(--brand-navy, #111827);\n}\n\n.wizard-steps-indicator .separator {\n  margin: 0 16px;\n  color: #E5E7EB;\n}\n\n.wizard-body {\n  background: var(--bg-surface, #fff);\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 4px 16px rgba(0,0,0,0.05);\n  margin-bottom: 24px;\n}\n\n.wizard-step h2 {\n  font-size: 22px;\n  margin: 0 0 24px 0;\n  color: #111827;\n  border-bottom: 1px solid #F3F4F6;\n  padding-bottom: 16px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-row {\n  display: flex;\n  gap: 16px;\n}\n\n.form-group.flex-1 { flex: 1; }\n.form-group.flex-2 { flex: 2; }\n\n.form-group label {\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.form-group input, \n.form-group select {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #D1D5DB;\n  border-radius: 8px;\n  font-size: 15px;\n  color: #111827;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: var(--brand-navy, #111827);\n  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.1);\n}\n\n.help-text {\n  font-size: 13px;\n  color: #6B7280;\n  margin: 6px 0 0 0;\n}\n\n.section-block {\n  background: #F9FAFB;\n  border: 1px solid #F3F4F6;\n  padding: 24px;\n  border-radius: 12px;\n  margin-bottom: 24px;\n}\n\n.section-block h3 {\n  margin: 0 0 16px 0;\n  font-size: 16px;\n  color: #374151;\n}\n\n/* Upload Container */\n.upload-container {\n  margin-top: 16px;\n}\n\n.upload-placeholder {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n  border: 2px dashed #D1D5DB;\n  border-radius: 12px;\n  background: #F9FAFB;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.upload-placeholder:hover {\n  border-color: var(--brand-navy, #111827);\n  background: #F3F4F6;\n}\n\n.upload-placeholder span {\n  font-weight: 600;\n  color: #6B7280;\n}\n\n.upload-placeholder input[type=\"file\"] {\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.capa-preview {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.capa-preview img {\n  max-width: 100%;\n  max-height: 400px;\n  border-radius: 12px;\n  object-fit: contain;\n  border: 1px solid #E5E7EB;\n}\n\n/* Footer Wizard */\n.wizard-footer {\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n}\n\n/* Buttons */\n.btn-primary {\n  background-color: var(--brand-navy, #111827);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.btn-primary:hover {\n  background-color: #374151;\n}\n\n.btn-primary.success {\n  background-color: #10B981;\n}\n.btn-primary.success:hover {\n  background-color: #059669;\n}\n\n.btn-outline {\n  background-color: transparent;\n  color: var(--brand-navy, #111827);\n  border: 1px solid var(--brand-navy, #111827);\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-outline:hover {\n  background-color: var(--brand-navy, #111827);\n  color: white;\n}\n\n.btn-outline.small {\n  padding: 6px 12px;\n  font-size: 13px;\n}\n\n.btn-outline.danger {\n  color: #EF4444;\n  border-color: #EF4444;\n}\n.btn-outline.danger:hover {\n  background-color: #EF4444;\n  color: white;\n}\n\n.mt-2 {\n  margin-top: 16px;\n}\n\n.summary-alert {\n  background: #ECFDF5;\n  border: 1px solid #34D399;\n  padding: 16px;\n  border-radius: 8px;\n  color: #065F46;\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
